import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@rb-serve-app/core';
import { getSafeNextFromSearch } from '../../utility/authRedirect';

type PublicRouteProps = {
  children: React.ReactElement;
};

const PublicRoute = ({ children }: PublicRouteProps) => {
  const location = useLocation();
  const { accountDetails, isAuthenticated, accountDetailsError } = useSelector(
    (state: RootState) => state.user
  );
  console.log(
    'deaails api response & errors',
    accountDetails,
    accountDetailsError
  );

  const safeNext = getSafeNextFromSearch(location.search);

  if (isAuthenticated && accountDetails) {
    return <Navigate to={safeNext || '/home'} replace />;
  }

  return children;
};

export default PublicRoute;
